import $ from 'jquery';
import Page from '../Page/_State';
// import AnchorDirect from '../AnchorLink/_AnchorDirect';

(() => {
  const bodyHtml = $('html,body');

  $('a.anc').click(function () {
    var href = $(this).attr('href');
    var timerDuration = 500;

    resetClass();
    // SekaiSen.app.ssset();

    // AnchorSekaisen.setSekaisen();
    // 世界線扉 強制非表示
    $('.sekai-tobira').removeClass('sekai-tobira--open');
    // $('.sekai-top-c2-btn').show();

    //世界線以降のブロックを表示する
    switch (href) {
      case '#page-top':
      case '#webtoon':
        // AnchorDirect.reset();
        Page.ins.goTo('top');
        break;
      case '#anc-fitting':
      case '#anc-erabikata':
      case '#anc-lineup':
      case '#anc-shindan':
        $('.lineup').addClass('lineup--opacity0');
        Page.ins.goTo('bottom-anc');
        break;
    }

    setTimeout(function () {
      var target = $(href == '#' || href == '' ? 'html' : href);
      var position = target.offset().top;

      //スクロール位置補完
      switch (href) {
        case '#anc-fitting':
          if ($(window).width() < 768) {
            position = position + 100;
          } else {
            // position = position + 380;
          }
          break;
        case '#anc-lineup':
          position = position + 20;
          break;
      }

      $('.lineup').removeClass('lineup--opacity0');
      bodyHtml.scrollTop(position);
    }, timerDuration);

    return false;
  });

  /*
   先延ばしにするクリック
   */
  $('a[href="#loop"]').click(function () {
    addClass();
    bodyHtml.animate({scrollTop: $('#loop').offset().top,},6000,'easeInCubic',function(){
      resetClass();
    });
    return false;
  });

  function addClass() {
    bodyHtml.addClass('over-flow--hidden');
  }

  function resetClass() {
    bodyHtml.removeClass('over-flow--hidden');
  }
})();
